import { camelCase } from 'lodash'

const files = require.context('.', true, /index\.js$/)
const modules = {}

files.keys().forEach(key => {
  if (key === './index.js') return
  const folder = key.replace(/(\.\/|index\.js)/g, '')
  const split = folder.split('/')

  if (split.length === 2) {
    const name = camelCase(split[0])
    modules[name] = files(key).default
  }
})

export default modules
